export default "__VITE_ASSET__BEWbYSqc__"